import React, { useEffect, useState } from "react";
import { Button, Checkbox, Select } from "antd";
import { AutoResizeTextArea } from "../../../components";
import ReactGA from "react-ga4";


const ReasonsValues = {
  ResultsNotRelevant: 1,
  ExpectedResultsMissing: 2,
  UserQueryNotUnderstood: 3,
  FiltersOrLocationNotCorrect: 4,
  TooSmallResultSet: 5,
  Other: 6,
}

const ReasonsLabels = {
  [ReasonsValues.ResultsNotRelevant]: "Rezultati nisu relevantni",
  [ReasonsValues.ExpectedResultsMissing]: "Nedostaju oglasi koje očekujem",
  [ReasonsValues.UserQueryNotUnderstood]: "Pogrešno je razumljen moj upit",
  [ReasonsValues.FiltersOrLocationNotCorrect]: "Filtri ili lokacija nisu ispravno primjenjeni",
  [ReasonsValues.TooSmallResultSet]: "Dobio/la sam premalo rezultata",
  [ReasonsValues.Other]: "Nešto drugo",
}

export const FeedbackForm = ({ handleSubmit, submitting, visible }) => {
  const [comment, setComment] = useState("");
  const [reasons, setReasons] = useState([]);

  useEffect(() => {
    if (!visible) {
      setComment("")
      setReasons([])
    }
  }, [visible])

  const handleReasonChange = (value: number, checked: boolean) => {
    setReasons(prev =>
      checked ? [...prev, value] : prev.filter(r => r !== value)
    );
  };



  const handleSubmitForm = (e: React.FormEvent) => {
    e.preventDefault();

    ReactGA.event({
      category: "Tekstualna pretraga",
      action: "Click",
      label: "Komentar - naslovnica"
    })

    handleSubmit(false, reasons, comment);

  };

  const isSubmitDisabled = reasons.length === 0 || submitting

  return (
    <form onSubmit={handleSubmitForm}>
      <p style={{ marginBottom: 10 }}>Što nije bilo u redu s rezultatima? Odaberite jednu ili više opcija.</p>
      <div style={{
        display: "flex",
        flexDirection: "column",
        gap: 7,
        marginBottom: 10,
      }}>
        {Object.values(ReasonsValues).map(value => (
          <Checkbox
            key={value}
            checked={reasons.includes(value)}
            onChange={e => handleReasonChange(value, e.target.checked)}
            style={{ marginLeft: 0 }}
          >
            {ReasonsLabels[value]}
          </Checkbox>
        ))}
      </div>
      <AutoResizeTextArea
        style={{
          width: "100%",
          minHeight: 100,
          padding: 8,
          borderRadius: 4,
          border: "1px solid #d9d9d9",
          boxSizing: "border-box",
          marginBottom: 16,
        }}
        placeholder="Dodatno objašnjenje (nije obavezno)"
        value={comment}
        onChange={(e) => setComment(e.target.value)}
      />

      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          htmlType="submit"
          type="primary"
          disabled={isSubmitDisabled}
          loading={submitting}
          size="large"
          style={{ fontWeight: 700, textTransform: "capitalize" }}
        >
          Pošalji
        </Button>
      </div>


    </form>
  );

}



// WEBPACK FOOTER //
// ./src/containers/SearchPage/AISearchResultsFeedbackForm/FeedbackForm.tsx